import path from 'path';

export function stringifyRequest(context: string, request: string) {
    const splitted = request.split('!');

    return JSON.stringify(
        splitted
            .map(part => {
                // First, separate singlePath from query, because the query might contain paths again
                const splittedPart = /^(.*?)(\?.*)/.exec(part);
                const query = splittedPart ? splittedPart[2] : '';
                let singlePath = splittedPart ? splittedPart[1] : part;

                if (isAbsolutePath(singlePath) && context) {
                    singlePath = path.relative(context, singlePath);
                }

                return singlePath.replace(/\\/g, '/') + query;
            })
            .join('!')
    );
}

function isAbsolutePath(str: string) {
    return path.posix.isAbsolute(str) || path.win32.isAbsolute(str);
}
